module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Document type name</th>\r\n        <th>Organization</th>\r\n        <th>Signs limit</th>\r\n        <th>Sign X</th>\r\n        <th>Sign Y</th>\r\n        <th>Sign width</th>\r\n        <th>Edit</th>\r\n        <th>Delete</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n<div class="left-buttons">\r\n    <button type="button" class="btn btn-success" id="add-document-type">Add new document type</button>\r\n</div>\r\n<div id="yes-no-confirmation-modal-for-update"></div>\r\n<div id="yes-no-confirmation-modal-for-delete"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/document-types/document-types-table.html
// module id = 458
// module chunks = 0